let stripe;
let cardNumber;

$(function() {
  let stripeKey;

  if ((stripeKey = document.querySelector("#js-stripe-key"))) {
    stripeKey = stripeKey.value;
  }

  const stripeForm = document.querySelector(".js-stripe-form");

  if (!stripeForm || !stripeKey) {
    return;
  }

  initStripeForm(stripeKey);
});

const getCardToken = function() {
  return new Promise((resolve, reject) => {
    stripe.createToken(cardNumber).then(function({ token, error = null }) {
      if (error) {
        reject(error);
      }

      resolve(token.id);
    });
  });
};

const initStripeForm = stripeKey => {
  stripe = Stripe(stripeKey);

  const elements = stripe.elements({
    fonts: [
      { cssSrc: "https://fonts.googleapis.com/css?family=Source+Sans+Pro" }
    ]
  });
  const style = {
    base: {
      color: "#666",
      fontFamily: '"Source Sans Pro", sans-serif',
      fontSize: "15px",
      fontWeight: 400,
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#666",
        fontFamily: '"Source Sans Pro", sans-serif',
        fontSize: "14px",
        fontWeight: 500,
        fontSmoothing: "initial"
      }
    }
  };
  const classes = {
    invalid: "has-error"
  };
  const cardNumberNode = document.getElementById("card-number");
  cardNumber = elements.create("cardNumber", {
    style,
    classes,
    placeholder:
      cardNumberNode.dataset.placeholder || "Enter Credit Card Number"
  });
  const cardExpiryNode = document.getElementById("card-expiry");
  const cardExpiry = elements.create("cardExpiry", {
    style,
    classes,
    placeholder:
      cardExpiryNode.dataset.placeholder || "Enter Expiration Date as MM/YY"
  });
  const cardCvcNode = document.getElementById("card-cvc");
  const cardCvc = elements.create("cardCvc", {
    style,
    classes,
    placeholder: cardCvcNode.dataset.placeholder || "Enter Security Code"
  });

  cardNumber.mount("#card-number");
  cardExpiry.mount("#card-expiry");
  cardCvc.mount("#card-cvc");
};

export { getCardToken, initStripeForm };



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/stripe.js